import React from 'react';
import { useNavigate } from 'react-router-dom';

const PublicEventSelector = () => {
  const navigate = useNavigate();

  const events = [
    {
      id: 'kontakt-fest-2026',
      name: 'KONTAKT Fest 2026',
      tagline: 'Největší festival v Beskydech',
      description: '2 dny plné hudby, zábavy a skvělého jídla v srdci Beskyd. Festival pro celou rodinu s bohatým programem na dvou pódiích.',
      details: '13. - 14. června 2026 | Frenštát pod Radhoštěm | 8 000+ návštěvníků',
      url: '/kontakt-fest',
      image: 'https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/cach2n83_kontaktfest0690-Pano.jpg'
    },
    {
      id: 'cesta-kolem-sveta-2026',
      name: 'Gastrofestival Cesta Kolem Světa',
      tagline: 'Mezinárodní gastronomický festival v centru města',
      description: 'Ochutnejte celosvětovou kuchyni na jednom místě. Více než 30 stánků s jídlem z celého světa, bohatý program pro děti a živá hudba.',
      details: '16. - 17. května 2026 | Masarykovo náměstí, Uherské Hradiště | 10 000+ návštěvníků',
      url: '/cesta-kolem-sveta',
      image: 'https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/3plv5bqw_fotka%20uvodni.jpg'
    },
    {
      id: 'majofest-otrokovice-2026',
      name: 'Májofest Otrokovice',
      tagline: 'Pivní festival s regionálními kapelami',
      description: '2. ročník pivního festivalu. 20 druhů piv, grilované speciality a živá hudba od FOCUS ROCK a regionálních kapel. Vstup zdarma!',
      details: '2. května 2026 | Otrokovice | 1 300+ návštěvníků',
      url: '/majofest',
      image: 'https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/b8q85k2n_Sni%CC%81mek%20obrazovky%202026-03-11%20v%C2%A021.29.47.png'
    },
    {
      id: 'burger-rock-fest-2026',
      name: 'Burger Rock Fest Napajedla',
      tagline: 'Burgery, rock a skvělá atmosféra!',
      description: '11. ročník tradiční akce. Burgery, rock kapely a večerní zábava na historickém nádvoří kláštera. Vstup zdarma!',
      details: '6. června 2026 | Nádvoří Nového Kláštera, Napajedla | 1 500+ návštěvníků',
      url: '/burger-fest',
      image: 'https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/ylzp4r80_burger%20fest.jpg'
    },
    {
      id: 'otrokovicke-letni-slavnosti-2026',
      name: 'Otrokovické letní slavnosti',
      tagline: 'Letní festival ve Zlínském kraji',
      description: 'Dvoudenní městský festival s koncerty známých interpretů, sportovní zónou, dětským programem a festivalovými bary v centru Otrokovic.',
      details: '10. - 11. července 2026 | Park před Společenským domem, Otrokovice | Několik tisíc návštěvníků',
      url: '/otrokovice',
      image: 'https://vseproakci.cz/wp-content/uploads/2025/06/OLS-pic.jpg'
    },
    {
      id: 'festival-koupacek-2026',
      name: 'Festival Koupáček',
      tagline: 'Rodinný festival na koupališti',
      description: 'Jednodenní festival pro celou rodinu. Den plný hudby, her, tvoření a zábavy pro děti i jejich rodiče v areálu městského koupaliště.',
      details: '5. července 2026 | Městské koupaliště, Otrokovice | 2 000+ návštěvníků',
      url: '/koupacek',
      image: 'https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/26hl5tl7_1920x1080%282%29.jpg'
    },
    {
      id: 'den-zk-2026',
      name: 'Den Zlínského kraje',
      tagline: 'Ochutnejte kraj všemi smysly',
      description: 'Roční setkání obyvatel Zlínského kraje. Bohatý program, regionální produkty, koncerty známých interpretů a atrakce pro celou rodinu. Vstup zdarma!',
      details: '26. září 2026 | Zlín, Baťův mrakodrap a okolí | Několik tisíc návštěvníků',
      url: '/den-zk',
      image: 'https://denzk.cz/wp-content/uploads/2021/10/1181_foto_Ji%C2%B2i_Balat-scaled.jpg'
    }
  ];

  return (
    <div className="min-h-screen bg-black">
      {/* Header - Logo */}
      <header className="bg-black py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <img 
            src="https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/hq5pofy8_VPA-logo-white.png"
            alt="VŠEPROAKCI"
            className="h-12 md:h-14"
          />
        </div>
      </header>

      {/* Title Section */}
      <section className="bg-black py-16 text-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-5xl md:text-6xl font-extralight text-white tracking-wide mb-4">
            Nabídka stánkových míst
          </h2>
        </div>
      </section>

      {/* Event Cards - Similar to "Naše hlavní služby" */}
      <section className="bg-black py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {events.map((event) => (
              <div 
                key={event.id}
                className="relative group overflow-hidden cursor-pointer"
                onClick={() => navigate(event.url)}
              >
                {/* Background Image */}
                <div className="relative h-[600px]">
                  <img 
                    src={event.image} 
                    alt={event.name}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  {/* Dark Overlay */}
                  <div className="absolute inset-0 bg-black/60"></div>
                  
                  {/* Content */}
                  <div className="absolute inset-0 flex flex-col justify-center items-center text-center p-12">
                    {/* Category */}
                    <p className="text-gray-300 text-sm font-light tracking-widest uppercase mb-6">
                      Festivals
                    </p>
                    
                    {/* Main Title */}
                    <h3 className="text-5xl md:text-6xl font-extralight text-white mb-6 leading-tight">
                      {event.name}
                    </h3>
                    
                    {/* Tagline - Cyan */}
                    <p className="text-cyan-400 text-xl md:text-2xl font-light mb-8 max-w-md">
                      {event.tagline}
                    </p>
                    
                    {/* Description */}
                    <p className="text-gray-300 text-base font-light leading-relaxed mb-4 max-w-lg">
                      {event.description}
                    </p>
                    
                    {/* Details */}
                    <p className="text-gray-400 text-sm font-light mb-10">
                      {event.details}
                    </p>
                    
                    {/* CTA Button - Cyan */}
                    <button 
                      className="bg-cyan-400 hover:bg-cyan-500 text-black font-light text-sm tracking-widest uppercase px-12 py-4 transition-all duration-300"
                      onClick={() => navigate(event.url)}
                    >
                      ZOBRAZIT DETAIL
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section - Cyan Gradient */}
      <section className="bg-gradient-to-r from-cyan-400 to-blue-500 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-8">
            <h2 className="text-4xl md:text-5xl font-extralight text-white tracking-wide">
              Pojďme naplánovat váš event!
            </h2>
            <a 
              href="mailto:ondruchova@event-time.cz"
              className="bg-black hover:bg-gray-900 text-white font-light text-sm tracking-widest uppercase px-12 py-4 transition-all duration-300 whitespace-nowrap"
            >
              NAPIŠTE NÁM
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            {/* Logo */}
            <div>
              <img 
                src="https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/hq5pofy8_VPA-logo-white.png"
                alt="VŠEPROAKCI"
                className="h-8 md:h-10 mb-6"
              />
            </div>
            
            {/* Contact */}
            <div>
              <p className="text-gray-400 text-sm font-light mb-2">J. Jablůnkové, 765 02</p>
              <p className="text-gray-400 text-sm font-light mb-4">Otrokovice</p>
              <p className="text-white text-lg font-light mb-2">+420 774 750 456</p>
              <p className="text-white text-sm font-light border-b border-white inline-block">
                info@vseproakci.cz
              </p>
            </div>
            
            {/* Info */}
            <div>
              <p className="text-gray-400 text-sm font-light leading-relaxed">
                Zásady ochrany osobních a dalších zpracovávaných údajů
              </p>
              <p className="text-gray-400 text-sm font-light leading-relaxed mt-4">
                Všeobecné obchodní podmínky pro akce na klíč
              </p>
            </div>
            
            {/* Company */}
            <div>
              <p className="text-white text-sm font-light mb-2">Vseproakci.cz</p>
              <p className="text-gray-400 text-sm font-light mb-1">IČ: 74956613</p>
              <p className="text-gray-400 text-sm font-light">DIČ: CZ8805254557</p>
            </div>
          </div>
          
          <div className="border-t border-gray-800 pt-8">
            <div className="flex justify-between items-center">
              <p className="text-gray-600 text-xs font-light">
                © 2026 Vše pro akci. All rights reserved.
              </p>
              <button 
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className="w-10 h-10 bg-white rounded-full flex items-center justify-center text-black hover:bg-gray-200 transition-colors"
              >
                ↑
              </button>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PublicEventSelector;
